/**
 * Pre-seeded welcome message shown in the chat panel at the end of the guided
 * tour (#1217). Surfaced as the agent's first message so new users land on
 * /chat with something to respond to.
 */
export const TOUR_WELCOME_MESSAGE =
  "Hey! Welcome to OpenHuman 👋 You just finished setting up, and I'm here whenever you need me. Ask me anything, get summaries from your connected apps, or just say hi — what would you like to explore first?";
